/* BannerSectionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./BannerSectionRenderer");
const _ = require("lodash");
const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19";

class BannerSectionComponent extends EventEmitter {
    constructor(
        logger,
        userService,
        userSession,
        router,
        SystemConfig,
        localStorage,
        storageFactory
    ) {
        super();
        this._renderer = new Renderer(this);

        this._logger = logger;
        this._userService = userService;
        this._userSession = userSession;
        this._router = router;
        this._SystemConfig = SystemConfig;
        this._localStorage = localStorage;
        this._storageFactory = storageFactory;
        this._sessionStorage = window.sessionStorage;
        this._redirect = undefined;

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer
            .shutdown()
            .then(() => (this._renderer = undefined))
            .catch(() => {
                //TODO - Handle any errors in shutting down.
            });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    whenModelIsReady() {
        return Promise.resolve().then(() => {
            return this._SystemConfig.loadSystemConfig(GSO_ID).then((data) => {
                this._redirect = _.get(this._router.getRouteDetails(), "rd.redirect", false);
                this._systemConfigEntity = data;
                return Promise.resolve(this._systemConfigEntity.banner);
            });
        });
    }

    returnToLogin() {
        const token = this._userSession.token || this._localStorage.getToken();
        localStorage.clear();
        location.href = `${window.origin}/session/logout/${token}%2Fbanner`;
    }

    updateUserBannerAccept() {
        this._userSession.user.acceptBanner({}).then(() => {
            this._sessionStorage.setItem(this._userSession.token + "isBannerAccepted", true);
            const loadPath = window.localStorage.getItem("loadpath");
            if (loadPath) {
                window.localStorage.removeItem("loadpath");
                window.location = loadPath;
                return;
            }
            if (this._redirect && this._redirect.s !== "Banner") {
                if (this._redirect.sln === "classic") {
                    window.location = window.origin + "/_app_/gluware_control/#!/s/Perspective/rd/";
                    return;
                }
                this._router.goTo(this._redirect);
                return;
            }
            let lastPathInfo = this._sessionStorage.getItem(
                this._userSession.user.id + "lastPathInfo"
            );
            if (lastPathInfo) {
                if (lastPathInfo.search("/s/Perspective/") >= 0) {
                    window.location.href =
                        window.origin + "/_app_/gluware_control/#!" + lastPathInfo;
                    return;
                } else if (lastPathInfo.search("/frontend/") >= 0) {
                    window.location = window.origin + lastPathInfo;
                } else {
                    window.location.hash = "#!" + lastPathInfo;
                    return;
                }
            }
            this._router.goTo({
                app: "GameConsole",
                s: "Dashboard",
                sln: null,
                sr: null,
                rd: {triggeredBy: "Banner"},
                ra: "dashboard",
            });
        });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

BannerSectionComponent.$inject = [
    "$teve.logger",
    "$teve.services.User",
    "$teve.userSession",
    "$teve.router",
    "$teve.entities.SystemConfig",
    "$teve.userLocalStorage",
    "$teve.storageFactory",
];

module.exports = BannerSectionComponent;
